import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const TASK_API_REDUCER_KEY = "taskApi";

export const taskApi = createApi({
  reducerPath: TASK_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["task"],
  endpoints: (builder) => ({
    getTasksAssignToyMe: builder.query({
      query: ({ page, limit, assignee }) => {
        if (!assignee) {
          return;
        }
        return {
          url: `tasks/?page=${page}&assignee=${assignee}&limit=${limit}`,
        };
      },
      providesTags: ["task"],
    }),
    getTasksAssignByMe: builder.query({
      query: ({ page, limit, reporter }) => {
        if (!reporter) {
          return;
        }
        return {
          url: `tasks/?page=${page}&reporter=${reporter}&limit=${limit}`,
        };
      },
      providesTags: ["task"],
    }),

    getTask: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `tasks/${id}/`,
        };
      },
      providesTags: ["task"],
    }),

    createTask: builder.mutation({
      query: (body) => ({
        url: `tasks/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["task"],
    }),
    updateTask: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `tasks/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["task"],
    }),

    deleteTask: builder.mutation({
      query: (id) => ({
        url: `tasks/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["task"],
    }),

    getNotifications: builder.query({
      query: () => {
        return {
          url: `notifications/`,
        };
      },
      providesTags: ["task"],
    }),

    readNotification: builder.mutation({
      query: (id) => ({
        url: `notifications/${id}/read/`,
        method: "PUT",
      }),
      invalidatesTags: ["task"],
    }),
  }),
});

export const {
  useCreateTaskMutation,
  useDeleteTaskMutation,
  useGetTaskQuery,
  useGetTasksAssignToyMeQuery,
  useUpdateTaskMutation,
  useGetTasksAssignByMeQuery,
  useGetNotificationsQuery,
  useReadNotificationMutation,
} = taskApi;
